export const downloadTextFile = ({ content, name, type = 'text/plain', }) => {
    const blob = new Blob([content], { type });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = name;
    link.click();
    URL.revokeObjectURL(link.href); // Clean up the object URL after download
};
